import { writable } from "svelte/store";

const searchResults = writable(undefined);

const searchResultsStore = {
  subscribe: searchResults.subscribe,
  set: searchResults.set,
  clear: () => {
    searchResults.set(undefined);
  },
};
export default searchResultsStore;
